"use client";

import React, { useState, useEffect } from 'react';

interface SSRWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const SSRWrapper: React.FC<SSRWrapperProps> = ({ 
  children, 
  fallback = null 
}) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Don't render anything on the server
  if (!isClient) {
    return <>{fallback}</>;
  }

  // Only render children on the client
  return <>{children}</>;
}; 